import { FolderIcon as FolderHeroicon } from "@heroicons/react/outline";
import * as React from "react";
import type { CSS } from "~/config/stitches";
import { styled } from "~/config/stitches";
import type { IconSizeValue } from "../Icon/Icon";
import { Icon } from "../Icon/Icon";
import { FolderIconAutomated } from "./components/FolderIconAutomated";
import { FolderIconChevron } from "./components/FolderIconChevron";
import { FolderIconCloud } from "./components/FolderIconCloud";
import { FolderIconLock } from "./components/FolderIconLock";
import { FolderIconSize, folderSizeToIconSize } from "./FolderIconConstant";

const FolderIconWrapper = styled("span", {
  ...{ position: "relative" },
  defaultVariants: {
    size: FolderIconSize.XLARGE,
  },
  variants: {
    size: {
      large: { height: "2rem", width: "2rem" },
      medium: { height: "1.5rem", width: "1.5rem" },
      small: { height: "1.25rem", width: "1.25rem" },
      xlarge: { height: "2.5rem", width: "2.5rem" },
    },
  },
});

type FolderIconProps = {
  locked?: boolean;
  cloud?: boolean;
  automated?: boolean;
  chevron?: boolean;
  size: "large" | "medium" | "small" | "xlarge";
  iconProps?: {
    css?: CSS;
  };
  children?: React.ReactNode;
};

const FolderIcon = (props: FolderIconProps) => {
  function getIconSizeFromFolderSize(
    size: "large" | "medium" | "small" | "xlarge"
  ): IconSizeValue {
    return folderSizeToIconSize.get(size) ?? "medium";
  }

  return (
    <FolderIconWrapper
      size={props.size}
      css={props.iconProps?.css}
      className="folderIcon"
    >
      <Icon label={`folder`} size={props.size} color="info">
        <FolderHeroicon />
      </Icon>
      {props.chevron && (
        <FolderIconChevron size={getIconSizeFromFolderSize(props.size)} />
      )}
      {props.locked && <FolderIconLock size={props.size} color="info" />}
      {props.cloud && <FolderIconCloud size={props.size} color="info" />}
      {props.automated && (
        <FolderIconAutomated size={props.size} color="info" />
      )}
      {props.children}
    </FolderIconWrapper>
  );
};

FolderIcon.defaultProps = {
  size: "xlarge",
};

export { FolderIcon, FolderIconSize };
export type { FolderIconProps };
